import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '../../app.config';
import { ProgressBarService } from '../../core/service/progress-bar.service';
import { VersionInfo } from "../model/version-info";
import { finalize, map, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class VersionInfoService {
  constructor(private client: HttpClient, 
    @Inject(APP_CONFIG) private _config: IAppConfig,
    private _progressBar: ProgressBarService) {
  }

  protected createModel(modelData: any): VersionInfo {
    return Object.assign(new VersionInfo(), modelData);
  }

  getWithoutId(): Observable<VersionInfo> {
    this._progressBar.start();

    return this.client.get<VersionInfo>(`${this._config.apiEndpointV2}/version-info`).pipe(
      map(item => this.createModel(item)),
      finalize(() => this._progressBar.stop())
    );
  }
}